export default __webpack_public_path__ + "static/media/previous-claim-icon.56f4a00f.svg";